<template>
  <div class="video-player">
    <div
      class="video-player__video video-js vjs-default-skin"
      @mouseover="showControlUi"
      @mouseleave="hideControlUi"
    >
      <div class="video-player__overlay" ref="videoOverlay" />
      <outline-button
        class="video-player__close-button"
        iconOnly
        noBorder
        buttonIcon="close"
        @click="handleCloseClick"
      />
      <video ref="video" controls :data-setup="dataSetup" preload="auto" :muted="muted" />
    </div>
  </div>
</template>

<script>
/**
 * Video overlay
 */
import video from './../mixins/video';
import OutlineButton from './../components/rb-button-outline';

export default {
  name: 'video-player',
  mixins: [video],
  components: {
    OutlineButton
  },

  methods: {
    handleCloseClick() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.video-player {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &__close-button {
    position: absolute;
    right: $size-right-hero-video-close-button;
    top: $size-top-hero-video-close-button;
    background: $color-background-close-button !important; // overiding video js styles for buttons
    z-index: 2;
    border-radius: 50%;
    .rb-button-outline {
      &__icon {
        height: $size-height-hero-video-close-button;
        width: $size-width-hero-video-close-button;
        &--icon {
          font-size: $size-font-size-hero-video-close-button;
        }
      }
    }
  }

  &__video {
    height: auto;

    // TODO: Replacing with constraint styling
    // min-width: 50vw;
    // max-width: 80vh;
    // max-height: 80vh;
    overflow: hidden;
    .vjs-controls-enabled {
      width: auto;
      height: auto;
    }
    &.video-js {
        border: $size-border-width-hero-video solid $color-hero-video-border;
        border-radius: $size-border-radius-hero-video;
        overflow: hidden;
      .vjs-tech {
        width: 100%;
        height: auto;
        border-radius: $size-border-radius-hero-video;
      }
      .vjs-fullscreen {
        .vjs-tech {
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .vjs-control-bar, .vjs-big-play-button, .vjs-menu-button, .vjs-menu-content {
        background-color: transparent;
      }
      .vjs-big-play-button, .vjs-time-tooltip,  {
        display: none;
      }
      .vjs-control-bar {
        bottom: 0;
        border-radius: $size-border-radius-hero-video;
        height: $size-height-hero-video-control-bar;
        display: flex;
        width: 90%;
        margin: 0 auto;
        align-items: center;
        z-index: 3;
        transition: opacity 500ms ease;
        &.hidden {
          opacity: 0;
        }
      }
      .vjs-control {
        height: $size-height-hero-video-control;
        margin-right: $size-margin-right-hero-video-control;
        &::before {
          font-size: $size-font-size-hero-video-control;
          line-height: $size-line-height-hero-video-control;
        }
        &:focus {
          &::before {
            text-shadow: none;
          }
        }
        &:hover {
          &::before {
            text-shadow: none;
          }
        }
        &.vjs-play-control {
          margin-left: $size-margin-left-hero-video-play-control;
        }
        &.vjs-fullscreen-control {
          margin-left: auto;
          margin-right: $size-margin-right-hero-video-fullscreen-control;
        }
      }
      .vjs-progress-control {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
        bottom: $size-bottom-hero-video-progress-control;
        width: 100%;
        &:hover {
          .vjs-mouse-display {
            display: none;
          }
          .vjs-play-progress {
            &::after {
              display: none;
            }
          }
        }
      }
      .vjs-time-control {
        @include body-copy-regular;
        height: $size-height-hero-video-time-control;
      }
      .vjs-resize-manager {
        display: none;
      }
      .vjs-play-progress, .vjs-slider-bar {
        background: $color-hero-play-progress;
      }
      .vjs-slider, .vjs-load-progress {
        background-color: $color-hero-load-progress;
      }
      .vjs-current-time, .vjs-duration, .vjs-time-divider {
        display: block;
      }
    }
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(-180deg, rgba(0,0,0,0.00) 75%, #000000 100%);
    border-radius: $size-border-radius-hero-video;
    z-index: 2;
    pointer-events: none;
    transition: opacity 500ms ease;
    &.hidden {
      opacity: 0;
    }
  }
}
</style>
